<template>
    <div class="home">
        <!--<Header/>-->
        <div class="box">
            <img :src="require('../assets/tu18.jpg')" class="img">
            <div class="propaganda">
                <p class="title_one">受人尊敬，员工满意的勘测行业领军者；</p>
                <p class="title_two">价值共创、值得信赖的城乡发展综合服务商</p>
            </div>

<!--            <el-carousel class="carousel" height="580px" :interval="3000">-->
<!--                <el-carousel-item v-for="(item ,index) in imgList" :key="item">-->
<!--                    <img :src=item class="img">-->
<!--                    <p class="slogan">{{sloganList[index]}}</p>-->
<!--                </el-carousel-item>-->
<!--            </el-carousel>-->
        </div>
        <!--<div class="banner">-->
        <!--<img src="../assets/homeBanner.jpg" class="img">-->
        <!--<p class="slogan">为顾客规避风险，创造价值</p>-->
        <!--</div>-->

        <div class="job">
            <h2>北勘院2027年校园招聘岗位需求</h2>
            <div class="table">
                <el-table
                    border
                    :data="tableData"
                    header-row-class-name="elHeader"
                    cell-class-name="elCell"
                    :highlight-current-row="false"
                    :span-method="objectSpanMethod"
                    style="width: 100%; margin-top: 20px">
                    <el-table-column
                            prop="type"
                            label="类  别"
                            align="center"
                            width="239">
                    </el-table-column>
                    <el-table-column
                            prop="situation"
                            align="center"
                            width="519"
                            label="专  业">
                    </el-table-column>
<!--                    <el-table-column-->
<!--                            prop="address"-->
<!--                            align="center"-->
<!--                            width="209"-->
<!--                            label="工作地点">-->
<!--                    </el-table-column>-->
                    <el-table-column
                            prop="degree"
                            align="center"
                            width="170"
                            label="学历">
                    </el-table-column>
                    <el-table-column
                            prop="number"
                            width="90"
                            align="center"
                            label="人数">
                    </el-table-column>
                </el-table>
            </div>

        </div>


      <div class="job">
        <h2>广东分公司2027年校园招聘岗位需求</h2>
        <div class="table">
          <el-table
            border
            :data="tableData1"
            header-row-class-name="elHeader"
            cell-class-name="elCell"
            :highlight-current-row="false"
            style="width: 100%; margin-top: 20px">
            <el-table-column
              prop="situation"
              align="center"
              label="专  业">
            </el-table-column>
            <!--                    <el-table-column-->
            <!--                            prop="address"-->
            <!--                            align="center"-->
            <!--                            width="209"-->
            <!--                            label="工作地点">-->
            <!--                    </el-table-column>-->
            <el-table-column
              prop="degree"
              align="center"
              width="170"
              label="学历">
            </el-table-column>
            <el-table-column
              prop="number"
              width="90"
              align="center"
              label="人数">
            </el-table-column>
          </el-table>
        </div>

      </div>
        <Footer/>
    </div>

</template>

<script>
    import Header from '../base/Header'
    import Footer from '../base/Footer'
    import tu1 from '../assets/tu1.jpg'
    import tu2 from '../assets/tu2.jpg'
    import tu3 from '../assets/tu3.jpg'
    import tu4 from '../assets/tu4.jpg'
    import tu5 from '../assets/tu5.jpg'
    import tu6 from '../assets/tu6.jpg'
    import tu8 from '../assets/tu8.jpg'
    import tu9 from '../assets/tu9.jpg'
    import tu10 from '../assets/tu10.jpg'
    import tu11 from '../assets/tu11.jpg'
    import tu14 from '../assets/tu14.jpg'
    import tu15 from '../assets/tu15.jpg'
    import tu17 from '../assets/tu17.jpg'
    import tu18 from '../assets/tu18.jpg'

    import {getRecruitList} from '../api';

    import { list } from './data.js';
    import { merge, spanMethod} from './mergeClass'


    export default {
        name: 'Home',
        props: {},
        components: {Header, Footer},
        data() {
            return {
                total: 0,
                page: 1,
                pageSize: 20,
                height: '300px',
                imgList: [
                    tu18,
                    // tu11,
                    // tu5,
                    // tu3,
                    // tu4,
                    // tu8,
                ],
                sloganList: [
                    '受人尊敬，员工满意的勘测行业领军者；' +
                    '价值共创、值得信赖的城乡发展综合服务商',
                    // '通过崇高的职业道德、严谨的执业作风',
                    // '不懈的技术创新和与时俱进的员工培训',
                    // '提供顾客满意、富有价值、值得信赖的专业产品与服务',
                    // '规避人类建设活动、项目投资人、使用者和环境的风险',
                    // '促进人类建设与环境的协调和社会的可持续发展',
                    // '保障利益相关方的合法权益',
                ],
                tableData: [],
                merge: {},
              tableData1: [
                {
                  situation: '岩土工程、地质工程、水文地质',
                  degree: '硕士/本科',
                  number: '2'
                },
                {
                  situation: '测绘工程',
                  degree: '硕士/本科',
                  number: '2'
                },
                {
                  situation: '管理学、法学等',
                  degree: '硕士',
                  number: '1'
                }
              ]
            }
        },
        created() {
            this.tableData = list;
            this.processing()
        },
        methods: {
            processing(){
                //可以进行级联合并，当第二个字段受第一个字段限制时候，放入其children中
                let countField = [
                    {
                        field: 'type',
                    },
                    {
                        field: 'situation',
                        // children: [{
                        //     field: 'address',
                        // }]
                    }
                ];

                this.merge = {};
                let das = this.merge;

                let merges = new merge(countField, das, this.tableData);
                merges.startCalculation();

                /**
                 * 如果涉及到三层级联，则需要在半秒后进行数据整合，为第三级以后setTimeout提供计算时间
                 */
                setTimeout(() => {
                    this.tableData = this.tableData;
                },500);
            },

            // /**
            //  * 官方提供的合并触发方法
            //  */
            objectSpanMethod({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    return spanMethod(this.merge['type'] || [], rowIndex);
                }
                if (columnIndex === 1) {
                    return spanMethod(this.merge['situation'] || [], rowIndex);
                }
                // if (columnIndex === 2) {
                //     return spanMethod(this.merge['address'] || [], rowIndex);
                // }

            },

            objectSpanMethods({ row, column, rowIndex, columnIndex }) {
                if (columnIndex === 0) {
                    // // 岩土类
                    // if(rowIndex === 0){
                    //     return [11, 1];
                    // }
                    // if([1,2,3,4,5,6,7,8,9,10, 12,13,14,15,16,17,18,19,20,21, 23,24,25].indexOf(rowIndex) != -1){
                    //     return {
                    //         rowspan: 0,
                    //         colspan: 0
                    //     };
                    // }
                    //
                    // //测绘类
                    // if(rowIndex === 11){
                    //     return [11, 1];
                    // }
                    //
                    // //设计类
                    // if(rowIndex === 22){
                    //     return [4, 1];
                    // }
                }
            },





            handleCurrentChange(val) {
                this.page = val;
                this.getTableList();
            },
            getTableList() {

                let params = {
                    data: {
                        hot: "1",
                        enable: 1,
                    },
                    orderBy: "addTime",
                    orderType: "asc",
                    pageNum: this.page,
                    pageSize: this.pageSize
                };


                getRecruitList(params).then((res) => {
                    let {list, total} = res.content;
                    this.tableData = list;
                    this.total = total;
                });
            }
        },


    }
</script>

<style scoped lang="less">
    .home {
        width: 100%;
        position: relative;

        img {
            width: 100%;
            height: 100%;
        }

        /*.banner {*/
            /*height: 580px;*/
            /*img {*/
                /*!*width: 100%;*!*/
                /*!*height: 100%;*!*/
            /*}*/

            /*.slogan {*/
                /*position: absolute;*/
                /*user-select: none;*/
                /*z-index: 2;*/
                /*top: 300px;*/
                /*left: 52%;*/
                /*font-size: 62px;*/
                /*line-height: 80px;*/
                /*text-align: left;*/
                /*color: #FFF;*/
                /*font-family: 华文新魏;*/
                /*text-shadow: 0px 15px 15px #00497f;*/
            /*}*/
        /*}*/
        .box{
            width: 100%;height: 600px;
            position: relative;
        }
        .propaganda{
            position: absolute;
            z-index: 2;
            top: 45%;
            right: 0;
            /*left: 50%;*/
            font-size: 45px;
            line-height: 80px;
            text-align: left;
            width: 900px;
            color: #FFF;
            font-family: 华文新魏;
            text-shadow: 5px 5px 5px #00497f;
        }
        .title_one{

        }
        .title_two{
            /*top: 50%;*/
            /*left: 50%;*/
        }

        .slogan {
            position: absolute;
            z-index: 2;
            top: 40%;
            left: 50%;
            font-size: 58px;
            line-height: 80px;
            text-align: left;
            width: 700px;
            color: #FFF;
            font-family: 华文新魏;
            text-shadow: 5px 5px 5px #00497f;
        }

        .job {
            width: 1100px;
            margin: 20px auto;
            background: #FFFFFF;
          padding-top: 50px;
          border-radius: 5px;
          box-shadow: 0 0 20px rgba(0,0,0,0.1);
            h2 {
                font-size: 30px;
                //margin: 30px 0 0 0;
                letter-spacing: 4px;
                font-weight: 700;
                color: #102b6a;
              text-align: center;
            }

            .table {
                padding: 50px 40px;
                //background-color: #fff;
                .el-table{
                    margin-top: 0!important;
                }
                /*.el-table {*/
                /*    padding: 20px;*/
                /*    a {*/
                /*        color: #606266;*/
                /*        text-decoration: none;*/
                /*    }*/
                /*}*/
                .item {
                    margin-top: 10px;
                }
            }
            .el-pagination {
                margin-top: 10px;
            }
        }
    }


</style>
<style lang="less">
    .el-carousel__arrow {
        height: 80px !important;
        width: 70px !important;
        border-radius: 5px !important;
        font-size: 28px !important;
    }
    .elHeader{
        color: #333333;
        font-size: 16px;
        font-weight: 800;
        background-color: #cccccc!important;
    }
    .elCell{
        padding: 7px 0!important;
        font-size: 16px;
    }
    .el-table--border, .el-table--group{
        border-color: rgb(217, 236, 255) !important;
        border-width: 2px!important;
    }
    .el-table--border::after, .el-table--group::after{
        background-color: rgb(217, 236, 255)!important;
        border-width: 2px!important;
    }
    .el-table--border::after, .el-table--group::after, .el-table::before{
        background-color: rgb(217, 236, 255)!important;
        border-width: 2px!important;
    }

    .el-table{
        td,th,tr{
            border-color: rgb(217, 236, 255)!important;
            border-width: 2px!important;
            color: #000000!important;
        }
    }
</style>
